import * as React from "react";
import { forwardRef } from "react";
const SvgTickIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.59 7.58008L10 14.1701L7.41 11.5901L6 13.0001L10 17.0001L18 9.00008L16.59 7.58008Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgTickIcon);
export { ForwardRef as ReactComponent };
